import React, { useState } from 'react';

import { getString } from '../../../../helpers/styles';
import icons from '../../../../shared/assets/icons/redesign';

const { Check } = icons;

export default function CommunityFilterTopicPopupContent({
  onClose,
  sortType,
  sortTypes,
  setSortType
}) {
  const [activeItem, setActiveItem] = useState(sortType);

  return (
    <>
      <div className="communityTopicList-filter-popup-header">
        <h4 className="communityTopicList-filter-popup-header-title">
          Sorteer de onderwerpen op
        </h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body communityTopicList-filter-popup-body">
        <ul className="community-list communityTopicList-filter-popup-list">
          {sortTypes.map((item) => (
            <li
              key={item}
              className={getString([
                {
                  value: 'community-list-item',
                  condition: true
                },
                {
                  value: 'community-list-item-active',
                  condition: activeItem === item
                }
              ])}
              onClick={() => setActiveItem(item)}
            >
              <label className="community-item-label">
                <input
                  type="radio"
                  className="community-radio-input"
                  checked={activeItem === item}
                  onChange={() => {}}
                />

                <span className="community-checkmark">
                  <Check className="community-checkmark-icon" />
                </span>

                {item}
              </label>
            </li>
          ))}
        </ul>

        <button
          onClick={() => {
            setSortType(activeItem);
            onClose();
          }}
          className="
            popup-button popup-button-primary
            communityTopicList-filter-popup-button
          "
        >
          Wijzigen
        </button>
      </div>
    </>
  );
}
